var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag",class:_vm.statusClass},[_vm._v("\n  "+_vm._s(_vm.status == 'Revoked' ? 'Rejected' : _vm.status)+" \n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }